import api from "../store/services/api";

export const addOrderBenefit = async (orderId, benefits) =>
  await api.post(`/pos/order/${orderId}/benefits/`, benefits);

export const removeOrderBenefit = (orderId, params) =>
  api.delete(`/pos/order/${orderId}/benefits/`, { params });

const BenefitsService = {
  addOrderBenefit,
  removeOrderBenefit,
};

export default BenefitsService;
